// extracted by mini-css-extract-plugin
module.exports = {"container":"FoodModalKeypad_container__Dm2bP","keyContainer":"FoodModalKeypad_keyContainer__dBp-0"};